










import Vue from "vue";
import { AxiosResponse, AxiosError } from "axios";
export default Vue.extend({
  mounted() {
    this.axios
      .get("/api/hello")
      .then((res: AxiosResponse) => {
        console.log("Successfully connected backend", res);
      })
      .catch((err: AxiosError) => {
        alert(err);
      });
  }
});
